/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_NotificationsInputs */

const th_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดการแจ้งเตือน`)
};

const en_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on notifications`)
};

const ja_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知をオンにする`)
};

const zh_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开通知`)
};

const es_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar notificaciones`)
};

const pt_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligar notificações`)
};

const id_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan notifikasi`)
};

const fr_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications`)
};

const tl_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan ang mga notipikasyon`)
};

const vi_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật thông báo`)
};

const ko_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 켜기`)
};

const de_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen einschalten`)
};

const ru_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить уведомления`)
};

const tr_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimleri aç`)
};

const it_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva le notifiche`)
};

const pl_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włącz powiadomienia`)
};

const uk_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увімкнути сповіщення`)
};

const hi_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ चालू करें`)
};

const ar_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل الإشعارات`)
};

const ms_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidupkan pemberitahuan`)
};

const bn_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি চালু করুন`)
};

const zh_tw2_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟通知`)
};

const zh_hk2_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟通知`)
};

const ur_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات چالو کریں`)
};

const fa_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روشن کردن اعلان‌ها`)
};

const sw_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washa arifa`)
};

const nl_enable_notifications = /** @type {(inputs: Enable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen aanzetten`)
};

/**
* | output |
* | --- |
* | "Turn on notifications" |
*
* @param {Enable_NotificationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const enable_notifications = /** @type {((inputs?: Enable_NotificationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_NotificationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_enable_notifications(inputs)
	if (locale === "ja") return ja_enable_notifications(inputs)
	if (locale === "zh") return zh_enable_notifications(inputs)
	if (locale === "es") return es_enable_notifications(inputs)
	if (locale === "pt") return pt_enable_notifications(inputs)
	if (locale === "id") return id_enable_notifications(inputs)
	if (locale === "fr") return fr_enable_notifications(inputs)
	if (locale === "tl") return tl_enable_notifications(inputs)
	if (locale === "vi") return vi_enable_notifications(inputs)
	if (locale === "ko") return ko_enable_notifications(inputs)
	if (locale === "de") return de_enable_notifications(inputs)
	if (locale === "ru") return ru_enable_notifications(inputs)
	if (locale === "tr") return tr_enable_notifications(inputs)
	if (locale === "it") return it_enable_notifications(inputs)
	if (locale === "pl") return pl_enable_notifications(inputs)
	if (locale === "uk") return uk_enable_notifications(inputs)
	if (locale === "hi") return hi_enable_notifications(inputs)
	if (locale === "ar") return ar_enable_notifications(inputs)
	if (locale === "ms") return ms_enable_notifications(inputs)
	if (locale === "bn") return bn_enable_notifications(inputs)
	if (locale === "zh-TW") return zh_tw2_enable_notifications(inputs)
	if (locale === "zh-HK") return zh_hk2_enable_notifications(inputs)
	if (locale === "ur") return ur_enable_notifications(inputs)
	if (locale === "fa") return fa_enable_notifications(inputs)
	if (locale === "sw") return sw_enable_notifications(inputs)
	if (locale === "nl") return nl_enable_notifications(inputs)
	return en_enable_notifications(inputs)
});